import { render, staticRenderFns } from "./TiposMedicamento.vue?vue&type=template&id=5fa2be76&scoped=true&"
import script from "./TiposMedicamento.vue?vue&type=script&lang=js&"
export * from "./TiposMedicamento.vue?vue&type=script&lang=js&"
import style0 from "./TiposMedicamento.vue?vue&type=style&index=0&id=5fa2be76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2be76",
  null
  
)

export default component.exports